/** Bỏ mọi dấu `/` thừa ở cuối origin — ghép chuỗi hai lần là ra `//` và canonical sai. */
export function normalizeOrigin(url: string): string {
  return url.replace(/\/+$/, '');
}

/**
 * Ghép origin + path thành URL tuyệt đối. Canonical và hreflang BẮT BUỘC tuyệt đối —
 * Google bỏ qua hreflang tương đối.
 */
export function absoluteUrl(origin: string, path: string): string {
  const base = normalizeOrigin(origin);
  if (path === '') return `${base}/`;
  return path.startsWith('/') ? `${base}${path}` : `${base}/${path}`;
}

/** Escape 5 ký tự XML. Thiếu bước này là sitemap vỡ ngay khi có `&` trong query. */
export function escapeXml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;');
}
